var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#94D357;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 191.61,
    y: 823.31,
    className: "st0",
    width: 155.93,
    height: 155.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.97,
    y: 663.46,
    className: "st0",
    width: 155.93,
    height: 315.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 723.77,
    y: 723.52,
    className: "st0",
    width: 155.94,
    height: 255.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.19,
    y: 535.53,
    className: "st0",
    width: 155.94,
    height: 443.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M904.39,221.12l0.12,84.98l93.98-0.13l-314.62,248.6L536.2,417.87l-27.87,18.63 c-47.1,31.5-460.69,308-480.84,323.12l50.98,67.99c14.82-10.98,266.94-179.94,449.22-301.81L679.5,666.32l408.02-322.37v122.33 h84.98V220.75L904.39,221.12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockGraphIcon);
export default __webpack_public_path__ + "static/media/stockGraphIcon.3403fcd3b37a9d87784ca10798b81680.svg";
export { ForwardRef as ReactComponent };